import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { ArchiveMenuComponent } from './archive-menu.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		MatMenuModule,
		GoMaterialModule
	],
	declarations: [
		ArchiveMenuComponent
	],
	exports: [
		ArchiveMenuComponent
	],
	providers: [
		TranslatePipe
	]
})
export class ArchiveMenuModule {}
